import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./component/LandingPage";
import ContactUsPage from "./component/ContactUsPage/ContactUsPage";
import PrivacyPolicyPage from "./component/Privacy Policy/PrivacyPoicyPage";
import TermsOfUsePage from "./component/TermsOfUse/TermsOfUsePage";
import DisclaimerPage from "./component/Disclaimer/DisclaimerPage";
import BlogsPage from "./component/Blogs/BlogsPage";
import BlogDetailPage from "./component/Blogs/BlogDetailPage";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { useEffect } from "react";

function App() {

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
        xxl: 2560,
      },
    },
  });

  useEffect(() => {
    if (process.env.REACT_APP_NEW_RELIC_ENABLED === "true") {
      const script = document.createElement("script");
      script.src = "/newrelic.js";
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path='/disclaimer' element={<DisclaimerPage />} />
          <Route path='/blogs' element={<BlogsPage />} />
          <Route path='/blogs/:slug' element={<BlogDetailPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
